// Service details data for each service page
export const serviceDetails = {
  es: {
    'desarrollo-de-software': {
      id: 'desarrollo-de-software',
      title: 'Desarrollo de Software',
      subtitle: 'Arquitecturas personalizadas construidas para escalar',
      description: 'Transformamos tus ideas en soluciones de software robustas y escalables. Nuestro equipo de expertos desarrolla aplicaciones web, móviles y empresariales utilizando las últimas tecnologías y mejores prácticas de la industria.',
      heroImage: 'https://images.unsplash.com/photo-1555066931-4365d14bab8c?w=1200',
      benefits: [
        {
          title: 'Escalabilidad Garantizada',
          description: 'Arquitecturas diseñadas para crecer con tu negocio, desde startups hasta empresas Fortune 500.',
          icon: 'TrendingUp'
        },
        {
          title: 'Código Limpio',
          description: 'Seguimos estándares de código rigurosos y documentación completa para mantenibilidad a largo plazo.',
          icon: 'Code2'
        },
        {
          title: 'Entrega Ágil',
          description: 'Metodologías ágiles que garantizan entregas incrementales y feedback continuo.',
          icon: 'Zap'
        },
        {
          title: 'Soporte 24/7',
          description: 'Equipo dedicado disponible para resolver cualquier incidencia en tiempo récord.',
          icon: 'Headphones'
        }
      ],
      process: [
        {
          step: 1,
          title: 'Descubrimiento',
          description: 'Analizamos tus necesidades, objetivos de negocio y requisitos técnicos en profundidad.'
        },
        {
          step: 2,
          title: 'Arquitectura',
          description: 'Diseñamos la arquitectura óptima, seleccionando las tecnologías más adecuadas para tu proyecto.'
        },
        {
          step: 3,
          title: 'Desarrollo',
          description: 'Construimos tu solución en sprints, con demos regulares y ajustes basados en tu feedback.'
        },
        {
          step: 4,
          title: 'Testing & QA',
          description: 'Pruebas exhaustivas automatizadas y manuales para garantizar la calidad del producto.'
        },
        {
          step: 5,
          title: 'Despliegue',
          description: 'Lanzamiento controlado con monitoreo continuo y optimización de rendimiento.'
        },
        {
          step: 6,
          title: 'Mantenimiento',
          description: 'Soporte continuo, actualizaciones de seguridad y evolución del producto.'
        }
      ],
      technologies: ['React', 'Node.js', 'Python', 'TypeScript', 'PostgreSQL', 'MongoDB', 'AWS', 'Docker', 'Kubernetes', 'GraphQL'],
      stats: [
        { value: '200+', label: 'Proyectos Entregados' },
        { value: '99.9%', label: 'Uptime Garantizado' },
        { value: '50+', label: 'Desarrolladores Senior' }
      ]
    },
    'implementacion-de-ia': {
      id: 'implementacion-de-ia',
      title: 'Implementación de IA',
      subtitle: 'Inteligencia Artificial que transforma tu negocio',
      description: 'Llevamos el poder de la inteligencia artificial a tu empresa. Desde chatbots inteligentes hasta sistemas de predicción avanzados, implementamos soluciones de IA que automatizan procesos y generan insights valiosos.',
      heroImage: 'https://images.unsplash.com/photo-1677442136019-21780ecad995?w=1200',
      benefits: [
        {
          title: 'Automatización Inteligente',
          description: 'Reduce costos operativos hasta un 60% automatizando tareas repetitivas con IA.',
          icon: 'Bot'
        },
        {
          title: 'Decisiones Data-Driven',
          description: 'Algoritmos predictivos que analizan patrones y anticipan tendencias del mercado.',
          icon: 'Brain'
        },
        {
          title: 'Experiencia Personalizada',
          description: 'Sistemas de recomendación que aumentan engagement y conversiones.',
          icon: 'Users'
        },
        {
          title: 'Procesamiento de Lenguaje',
          description: 'NLP avanzado para análisis de sentimiento, chatbots y asistentes virtuales.',
          icon: 'MessageSquare'
        }
      ],
      process: [
        {
          step: 1,
          title: 'Evaluación de Datos',
          description: 'Auditamos tus fuentes de datos y evaluamos la viabilidad de implementación de IA.'
        },
        {
          step: 2,
          title: 'Estrategia de IA',
          description: 'Definimos los casos de uso con mayor ROI y diseñamos la arquitectura de ML.'
        },
        {
          step: 3,
          title: 'Preparación de Datos',
          description: 'Limpieza, transformación y enriquecimiento de datos para entrenamiento de modelos.'
        },
        {
          step: 4,
          title: 'Desarrollo de Modelos',
          description: 'Entrenamiento y optimización de modelos de machine learning y deep learning.'
        },
        {
          step: 5,
          title: 'Integración',
          description: 'Despliegue de modelos en producción con APIs y pipelines de datos en tiempo real.'
        },
        {
          step: 6,
          title: 'Monitoreo & Mejora',
          description: 'Seguimiento continuo del rendimiento y reentrenamiento de modelos.'
        }
      ],
      technologies: ['TensorFlow', 'PyTorch', 'OpenAI', 'LangChain', 'Scikit-learn', 'Hugging Face', 'MLflow', 'Pandas', 'Apache Spark', 'Vertex AI'],
      stats: [
        { value: '85%', label: 'Precisión Promedio' },
        { value: '60%', label: 'Reducción de Costos' },
        { value: '40+', label: 'Modelos en Producción' }
      ]
    },
    'digitalizacion': {
      id: 'digitalizacion',
      title: 'Digitalización',
      subtitle: 'Transformando lo legacy en definidor de legados',
      description: 'Modernizamos tu infraestructura tecnológica para la era digital. Migramos sistemas legacy, automatizamos procesos manuales y optimizamos flujos de trabajo para aumentar la eficiencia operativa.',
      heroImage: 'https://images.unsplash.com/photo-1451187580459-43490279c0fa?w=1200',
      benefits: [
        {
          title: 'Migración Sin Fricciones',
          description: 'Transición suave de sistemas legacy a plataformas modernas sin interrumpir operaciones.',
          icon: 'RefreshCw'
        },
        {
          title: 'Procesos Automatizados',
          description: 'Eliminamos tareas manuales con workflows digitales inteligentes.',
          icon: 'Workflow'
        },
        {
          title: 'Cloud Native',
          description: 'Infraestructura escalable en la nube con costos optimizados.',
          icon: 'Cloud'
        },
        {
          title: 'Datos Centralizados',
          description: 'Unificamos fuentes de datos dispersas en una única fuente de verdad.',
          icon: 'Database'
        }
      ],
      process: [
        {
          step: 1,
          title: 'Auditoría Digital',
          description: 'Evaluación completa de tu madurez digital y sistemas actuales.'
        },
        {
          step: 2,
          title: 'Roadmap de Transformación',
          description: 'Plan estratégico priorizado por impacto y complejidad.'
        },
        {
          step: 3,
          title: 'Modernización',
          description: 'Actualización de sistemas legacy y migración a arquitecturas modernas.'
        },
        {
          step: 4,
          title: 'Automatización',
          description: 'Implementación de RPA y workflows digitales.'
        },
        {
          step: 5,
          title: 'Migración Cloud',
          description: 'Traslado seguro de infraestructura a la nube.'
        },
        {
          step: 6,
          title: 'Optimización Continua',
          description: 'Mejora constante basada en métricas y KPIs.'
        }
      ],
      technologies: ['AWS', 'Azure', 'Google Cloud', 'Terraform', 'Kubernetes', 'Jenkins', 'GitHub Actions', 'Zapier', 'Power Automate', 'Datadog'],
      stats: [
        { value: '70%', label: 'Reducción de Tiempo' },
        { value: '45%', label: 'Ahorro en Costos IT' },
        { value: '100+', label: 'Migraciones Exitosas' }
      ]
    },
    'consultoria-tech': {
      id: 'consultoria-tech',
      title: 'Consultoría Tech',
      subtitle: 'Estrategia tecnológica que impulsa resultados',
      description: 'Asesoramiento experto para tomar las decisiones tecnológicas correctas. Definimos arquitecturas, evaluamos tecnologías y creamos roadmaps que alinean tu estrategia de IT con los objetivos de negocio.',
      heroImage: 'https://images.unsplash.com/photo-1552664730-d307ca884978?w=1200',
      benefits: [
        {
          title: 'Visión Estratégica',
          description: 'Alineamos tecnología con objetivos de negocio para maximizar el ROI.',
          icon: 'Target'
        },
        {
          title: 'Arquitectura Óptima',
          description: 'Diseños técnicos que balancean rendimiento, costo y mantenibilidad.',
          icon: 'Layout'
        },
        {
          title: 'Evaluación de Tecnologías',
          description: 'Análisis objetivo de herramientas y plataformas para tu contexto específico.',
          icon: 'Search'
        },
        {
          title: 'Transferencia de Conocimiento',
          description: 'Capacitamos a tu equipo para que sea autosuficiente.',
          icon: 'GraduationCap'
        }
      ],
      process: [
        {
          step: 1,
          title: 'Assessment Inicial',
          description: 'Evaluación profunda de tu situación actual y objetivos.'
        },
        {
          step: 2,
          title: 'Análisis de Brechas',
          description: 'Identificación de gaps entre estado actual y deseado.'
        },
        {
          step: 3,
          title: 'Diseño de Solución',
          description: 'Arquitectura técnica y selección de tecnologías.'
        },
        {
          step: 4,
          title: 'Roadmap Estratégico',
          description: 'Plan de implementación con hitos y métricas de éxito.'
        },
        {
          step: 5,
          title: 'Acompañamiento',
          description: 'Soporte durante la ejecución del plan.'
        },
        {
          step: 6,
          title: 'Revisión & Ajuste',
          description: 'Evaluación de resultados y optimización continua.'
        }
      ],
      technologies: ['Enterprise Architecture', 'TOGAF', 'Cloud Strategy', 'DevOps', 'Agile', 'Microservices', 'API Design', 'Security Assessment', 'Cost Optimization', 'Technical Due Diligence'],
      stats: [
        { value: '150+', label: 'Clientes Asesorados' },
        { value: '35%', label: 'Mejora en Eficiencia' },
        { value: '20+', label: 'Años de Experiencia' }
      ]
    },
    'project-management': {
      id: 'project-management',
      title: 'Project Management',
      subtitle: 'Gestión ágil que garantiza resultados',
      description: 'Lideramos tus proyectos tecnológicos con metodologías probadas. Desde la planificación hasta la entrega, aseguramos que cada proyecto se complete a tiempo, dentro del presupuesto y con la máxima calidad.',
      heroImage: 'https://images.unsplash.com/photo-1507925921958-8a62f3d1a50d?w=1200',
      benefits: [
        {
          title: 'Entregas Predecibles',
          description: 'Metodologías ágiles que garantizan visibilidad y control en cada sprint.',
          icon: 'Calendar'
        },
        {
          title: 'Equipos de Alto Rendimiento',
          description: 'Formación y liderazgo de equipos multidisciplinarios efectivos.',
          icon: 'Users'
        },
        {
          title: 'Gestión de Riesgos',
          description: 'Identificación temprana y mitigación proactiva de riesgos.',
          icon: 'Shield'
        },
        {
          title: 'Comunicación Transparente',
          description: 'Reportes claros y comunicación constante con stakeholders.',
          icon: 'MessageCircle'
        }
      ],
      process: [
        {
          step: 1,
          title: 'Iniciación',
          description: 'Definición de alcance, objetivos y stakeholders del proyecto.'
        },
        {
          step: 2,
          title: 'Planificación',
          description: 'Creación del plan de proyecto, cronograma y asignación de recursos.'
        },
        {
          step: 3,
          title: 'Ejecución',
          description: 'Gestión diaria del equipo, sprints y entregas incrementales.'
        },
        {
          step: 4,
          title: 'Monitoreo',
          description: 'Seguimiento de KPIs, burndown charts y métricas de calidad.'
        },
        {
          step: 5,
          title: 'Control de Cambios',
          description: 'Gestión estructurada de cambios de alcance y prioridades.'
        },
        {
          step: 6,
          title: 'Cierre',
          description: 'Entrega final, documentación y lecciones aprendidas.'
        }
      ],
      technologies: ['Scrum', 'Kanban', 'SAFe', 'Jira', 'Confluence', 'Monday.com', 'Asana', 'Microsoft Project', 'Notion', 'Slack'],
      stats: [
        { value: '95%', label: 'Proyectos a Tiempo' },
        { value: '300+', label: 'Proyectos Gestionados' },
        { value: '98%', label: 'Satisfacción Cliente' }
      ]
    },
    'ciberseguridad': {
      id: 'ciberseguridad',
      title: 'Ciberseguridad',
      subtitle: 'Protección integral para tu negocio digital',
      description: 'Protegemos tu infraestructura, datos y reputación contra amenazas cibernéticas. Desde auditorías de seguridad hasta respuesta a incidentes, ofrecemos soluciones completas de ciberseguridad.',
      heroImage: 'https://images.unsplash.com/photo-1550751827-4bd374c3f58b?w=1200',
      benefits: [
        {
          title: 'Detección de Amenazas',
          description: 'Monitoreo 24/7 con IA para identificar y neutralizar amenazas en tiempo real.',
          icon: 'Eye'
        },
        {
          title: 'Pentesting Profesional',
          description: 'Pruebas de penetración éticas que revelan vulnerabilidades antes que los atacantes.',
          icon: 'Bug'
        },
        {
          title: 'Cumplimiento Normativo',
          description: 'Aseguramos compliance con GDPR, ISO 27001, SOC 2 y más.',
          icon: 'FileCheck'
        },
        {
          title: 'Respuesta a Incidentes',
          description: 'Equipo de respuesta rápida para contener y remediar brechas de seguridad.',
          icon: 'AlertTriangle'
        }
      ],
      process: [
        {
          step: 1,
          title: 'Evaluación de Riesgos',
          description: 'Análisis completo de tu superficie de ataque y vulnerabilidades.'
        },
        {
          step: 2,
          title: 'Pentesting',
          description: 'Pruebas de penetración en aplicaciones, redes e infraestructura.'
        },
        {
          step: 3,
          title: 'Plan de Remediación',
          description: 'Priorización y corrección de vulnerabilidades identificadas.'
        },
        {
          step: 4,
          title: 'Hardening',
          description: 'Fortalecimiento de sistemas, redes y configuraciones.'
        },
        {
          step: 5,
          title: 'Monitoreo Continuo',
          description: 'Implementación de SIEM y monitoreo de seguridad 24/7.'
        },
        {
          step: 6,
          title: 'Capacitación',
          description: 'Entrenamiento de empleados en awareness de seguridad.'
        }
      ],
      technologies: ['Burp Suite', 'Metasploit', 'Nessus', 'Splunk', 'CrowdStrike', 'Palo Alto', 'Cloudflare', 'HashiCorp Vault', 'OWASP', 'Zero Trust'],
      stats: [
        { value: '500+', label: 'Auditorías Realizadas' },
        { value: '10K+', label: 'Vulnerabilidades Detectadas' },
        { value: '0', label: 'Brechas Post-Auditoría' }
      ]
    }
  },
  en: {
    'software-development': {
      id: 'software-development',
      title: 'Software Development',
      subtitle: 'Custom architectures built to scale',
      description: 'We transform your ideas into robust and scalable software solutions. Our team of experts develops web, mobile, and enterprise applications using the latest technologies and industry best practices.',
      heroImage: 'https://images.unsplash.com/photo-1555066931-4365d14bab8c?w=1200',
      benefits: [
        {
          title: 'Guaranteed Scalability',
          description: 'Architectures designed to grow with your business, from startups to Fortune 500 companies.',
          icon: 'TrendingUp'
        },
        {
          title: 'Clean Code',
          description: 'We follow rigorous code standards and complete documentation for long-term maintainability.',
          icon: 'Code2'
        },
        {
          title: 'Agile Delivery',
          description: 'Agile methodologies that guarantee incremental deliveries and continuous feedback.',
          icon: 'Zap'
        },
        {
          title: '24/7 Support',
          description: 'Dedicated team available to resolve any issue in record time.',
          icon: 'Headphones'
        }
      ],
      process: [
        {
          step: 1,
          title: 'Discovery',
          description: 'We analyze your needs, business objectives, and technical requirements in depth.'
        },
        {
          step: 2,
          title: 'Architecture',
          description: 'We design the optimal architecture, selecting the most suitable technologies for your project.'
        },
        {
          step: 3,
          title: 'Development',
          description: 'We build your solution in sprints, with regular demos and adjustments based on your feedback.'
        },
        {
          step: 4,
          title: 'Testing & QA',
          description: 'Exhaustive automated and manual testing to guarantee product quality.'
        },
        {
          step: 5,
          title: 'Deployment',
          description: 'Controlled launch with continuous monitoring and performance optimization.'
        },
        {
          step: 6,
          title: 'Maintenance',
          description: 'Ongoing support, security updates, and product evolution.'
        }
      ],
      technologies: ['React', 'Node.js', 'Python', 'TypeScript', 'PostgreSQL', 'MongoDB', 'AWS', 'Docker', 'Kubernetes', 'GraphQL'],
      stats: [
        { value: '200+', label: 'Projects Delivered' },
        { value: '99.9%', label: 'Guaranteed Uptime' },
        { value: '50+', label: 'Senior Developers' }
      ]
    },
    'ai-implementation': {
      id: 'ai-implementation',
      title: 'AI Implementation',
      subtitle: 'Artificial Intelligence that transforms your business',
      description: 'We bring the power of artificial intelligence to your company. From intelligent chatbots to advanced prediction systems, we implement AI solutions that automate processes and generate valuable insights.',
      heroImage: 'https://images.unsplash.com/photo-1677442136019-21780ecad995?w=1200',
      benefits: [
        {
          title: 'Intelligent Automation',
          description: 'Reduce operational costs by up to 60% by automating repetitive tasks with AI.',
          icon: 'Bot'
        },
        {
          title: 'Data-Driven Decisions',
          description: 'Predictive algorithms that analyze patterns and anticipate market trends.',
          icon: 'Brain'
        },
        {
          title: 'Personalized Experience',
          description: 'Recommendation systems that increase engagement and conversions.',
          icon: 'Users'
        },
        {
          title: 'Language Processing',
          description: 'Advanced NLP for sentiment analysis, chatbots, and virtual assistants.',
          icon: 'MessageSquare'
        }
      ],
      process: [
        {
          step: 1,
          title: 'Data Evaluation',
          description: 'We audit your data sources and evaluate AI implementation feasibility.'
        },
        {
          step: 2,
          title: 'AI Strategy',
          description: 'We define use cases with highest ROI and design ML architecture.'
        },
        {
          step: 3,
          title: 'Data Preparation',
          description: 'Data cleaning, transformation, and enrichment for model training.'
        },
        {
          step: 4,
          title: 'Model Development',
          description: 'Training and optimization of machine learning and deep learning models.'
        },
        {
          step: 5,
          title: 'Integration',
          description: 'Model deployment in production with APIs and real-time data pipelines.'
        },
        {
          step: 6,
          title: 'Monitoring & Improvement',
          description: 'Continuous performance tracking and model retraining.'
        }
      ],
      technologies: ['TensorFlow', 'PyTorch', 'OpenAI', 'LangChain', 'Scikit-learn', 'Hugging Face', 'MLflow', 'Pandas', 'Apache Spark', 'Vertex AI'],
      stats: [
        { value: '85%', label: 'Average Accuracy' },
        { value: '60%', label: 'Cost Reduction' },
        { value: '40+', label: 'Models in Production' }
      ]
    },
    'digitalization': {
      id: 'digitalization',
      title: 'Digitalization',
      subtitle: 'Transforming legacy into legacy-defining',
      description: 'We modernize your technological infrastructure for the digital age. We migrate legacy systems, automate manual processes, and optimize workflows to increase operational efficiency.',
      heroImage: 'https://images.unsplash.com/photo-1451187580459-43490279c0fa?w=1200',
      benefits: [
        {
          title: 'Frictionless Migration',
          description: 'Smooth transition from legacy systems to modern platforms without disrupting operations.',
          icon: 'RefreshCw'
        },
        {
          title: 'Automated Processes',
          description: 'We eliminate manual tasks with intelligent digital workflows.',
          icon: 'Workflow'
        },
        {
          title: 'Cloud Native',
          description: 'Scalable cloud infrastructure with optimized costs.',
          icon: 'Cloud'
        },
        {
          title: 'Centralized Data',
          description: 'We unify dispersed data sources into a single source of truth.',
          icon: 'Database'
        }
      ],
      process: [
        {
          step: 1,
          title: 'Digital Audit',
          description: 'Complete evaluation of your digital maturity and current systems.'
        },
        {
          step: 2,
          title: 'Transformation Roadmap',
          description: 'Strategic plan prioritized by impact and complexity.'
        },
        {
          step: 3,
          title: 'Modernization',
          description: 'Legacy system updates and migration to modern architectures.'
        },
        {
          step: 4,
          title: 'Automation',
          description: 'RPA and digital workflow implementation.'
        },
        {
          step: 5,
          title: 'Cloud Migration',
          description: 'Secure infrastructure migration to the cloud.'
        },
        {
          step: 6,
          title: 'Continuous Optimization',
          description: 'Constant improvement based on metrics and KPIs.'
        }
      ],
      technologies: ['AWS', 'Azure', 'Google Cloud', 'Terraform', 'Kubernetes', 'Jenkins', 'GitHub Actions', 'Zapier', 'Power Automate', 'Datadog'],
      stats: [
        { value: '70%', label: 'Time Reduction' },
        { value: '45%', label: 'IT Cost Savings' },
        { value: '100+', label: 'Successful Migrations' }
      ]
    },
    'tech-consulting': {
      id: 'tech-consulting',
      title: 'Tech Consulting',
      subtitle: 'Technology strategy that drives results',
      description: 'Expert advice to make the right technology decisions. We define architectures, evaluate technologies, and create roadmaps that align your IT strategy with business objectives.',
      heroImage: 'https://images.unsplash.com/photo-1552664730-d307ca884978?w=1200',
      benefits: [
        {
          title: 'Strategic Vision',
          description: 'We align technology with business objectives to maximize ROI.',
          icon: 'Target'
        },
        {
          title: 'Optimal Architecture',
          description: 'Technical designs that balance performance, cost, and maintainability.',
          icon: 'Layout'
        },
        {
          title: 'Technology Evaluation',
          description: 'Objective analysis of tools and platforms for your specific context.',
          icon: 'Search'
        },
        {
          title: 'Knowledge Transfer',
          description: 'We train your team to be self-sufficient.',
          icon: 'GraduationCap'
        }
      ],
      process: [
        {
          step: 1,
          title: 'Initial Assessment',
          description: 'Deep evaluation of your current situation and objectives.'
        },
        {
          step: 2,
          title: 'Gap Analysis',
          description: 'Identification of gaps between current and desired state.'
        },
        {
          step: 3,
          title: 'Solution Design',
          description: 'Technical architecture and technology selection.'
        },
        {
          step: 4,
          title: 'Strategic Roadmap',
          description: 'Implementation plan with milestones and success metrics.'
        },
        {
          step: 5,
          title: 'Accompaniment',
          description: 'Support during plan execution.'
        },
        {
          step: 6,
          title: 'Review & Adjust',
          description: 'Results evaluation and continuous optimization.'
        }
      ],
      technologies: ['Enterprise Architecture', 'TOGAF', 'Cloud Strategy', 'DevOps', 'Agile', 'Microservices', 'API Design', 'Security Assessment', 'Cost Optimization', 'Technical Due Diligence'],
      stats: [
        { value: '150+', label: 'Clients Advised' },
        { value: '35%', label: 'Efficiency Improvement' },
        { value: '20+', label: 'Years of Experience' }
      ]
    },
    'project-management': {
      id: 'project-management',
      title: 'Project Management',
      subtitle: 'Agile management that guarantees results',
      description: 'We lead your technology projects with proven methodologies. From planning to delivery, we ensure every project is completed on time, within budget, and with maximum quality.',
      heroImage: 'https://images.unsplash.com/photo-1507925921958-8a62f3d1a50d?w=1200',
      benefits: [
        {
          title: 'Predictable Deliveries',
          description: 'Agile methodologies that guarantee visibility and control in every sprint.',
          icon: 'Calendar'
        },
        {
          title: 'High-Performance Teams',
          description: 'Formation and leadership of effective multidisciplinary teams.',
          icon: 'Users'
        },
        {
          title: 'Risk Management',
          description: 'Early identification and proactive risk mitigation.',
          icon: 'Shield'
        },
        {
          title: 'Transparent Communication',
          description: 'Clear reports and constant communication with stakeholders.',
          icon: 'MessageCircle'
        }
      ],
      process: [
        {
          step: 1,
          title: 'Initiation',
          description: 'Definition of scope, objectives, and project stakeholders.'
        },
        {
          step: 2,
          title: 'Planning',
          description: 'Creation of project plan, schedule, and resource allocation.'
        },
        {
          step: 3,
          title: 'Execution',
          description: 'Daily team management, sprints, and incremental deliveries.'
        },
        {
          step: 4,
          title: 'Monitoring',
          description: 'KPI tracking, burndown charts, and quality metrics.'
        },
        {
          step: 5,
          title: 'Change Control',
          description: 'Structured management of scope and priority changes.'
        },
        {
          step: 6,
          title: 'Closure',
          description: 'Final delivery, documentation, and lessons learned.'
        }
      ],
      technologies: ['Scrum', 'Kanban', 'SAFe', 'Jira', 'Confluence', 'Monday.com', 'Asana', 'Microsoft Project', 'Notion', 'Slack'],
      stats: [
        { value: '95%', label: 'On-Time Projects' },
        { value: '300+', label: 'Managed Projects' },
        { value: '98%', label: 'Client Satisfaction' }
      ]
    },
    'cybersecurity': {
      id: 'cybersecurity',
      title: 'Cybersecurity',
      subtitle: 'Comprehensive protection for your digital business',
      description: 'We protect your infrastructure, data, and reputation against cyber threats. From security audits to incident response, we offer complete cybersecurity solutions.',
      heroImage: 'https://images.unsplash.com/photo-1550751827-4bd374c3f58b?w=1200',
      benefits: [
        {
          title: 'Threat Detection',
          description: '24/7 AI-powered monitoring to identify and neutralize threats in real time.',
          icon: 'Eye'
        },
        {
          title: 'Professional Pentesting',
          description: 'Ethical penetration testing that reveals vulnerabilities before attackers do.',
          icon: 'Bug'
        },
        {
          title: 'Regulatory Compliance',
          description: 'We ensure compliance with GDPR, ISO 27001, SOC 2, and more.',
          icon: 'FileCheck'
        },
        {
          title: 'Incident Response',
          description: 'Rapid response team to contain and remediate security breaches.',
          icon: 'AlertTriangle'
        }
      ],
      process: [
        {
          step: 1,
          title: 'Risk Assessment',
          description: 'Complete analysis of your attack surface and vulnerabilities.'
        },
        {
          step: 2,
          title: 'Pentesting',
          description: 'Penetration testing on applications, networks, and infrastructure.'
        },
        {
          step: 3,
          title: 'Remediation Plan',
          description: 'Prioritization and correction of identified vulnerabilities.'
        },
        {
          step: 4,
          title: 'Hardening',
          description: 'Strengthening of systems, networks, and configurations.'
        },
        {
          step: 5,
          title: 'Continuous Monitoring',
          description: 'SIEM implementation and 24/7 security monitoring.'
        },
        {
          step: 6,
          title: 'Training',
          description: 'Employee security awareness training.'
        }
      ],
      technologies: ['Burp Suite', 'Metasploit', 'Nessus', 'Splunk', 'CrowdStrike', 'Palo Alto', 'Cloudflare', 'HashiCorp Vault', 'OWASP', 'Zero Trust'],
      stats: [
        { value: '500+', label: 'Audits Performed' },
        { value: '10K+', label: 'Vulnerabilities Detected' },
        { value: '0', label: 'Post-Audit Breaches' }
      ]
    }
  }
};

// Map service IDs between languages
export const serviceIdMap = {
  es: {
    0: 'desarrollo-de-software',
    1: 'implementacion-de-ia',
    2: 'digitalizacion',
    3: 'consultoria-tech',
    4: 'project-management',
    5: 'ciberseguridad'
  },
  en: {
    0: 'software-development',
    1: 'ai-implementation',
    2: 'digitalization',
    3: 'tech-consulting',
    4: 'project-management',
    5: 'cybersecurity'
  }
};

export default serviceDetails;
